






































































































































































































































































































import config from '@/config/index';
import HandleErrors from '@/config/handleErrors';
import Confirmation from '@/components/Confirmation.vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { PerfilesInterface } from '@/interfaces/Perfiles';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { EstadoEntidad, TipoRol } from '@/config/enums';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Validator } from 'vee-validate';
import { RolesInterface } from '@/interfaces/Roles';
import store from '@/store';
import { differenceBy } from 'lodash';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import {
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  CellContextMenuEvent,
  RowNode,
} from 'ag-grid-community';

const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
  },
})
export default class PerfilesModalNuevo extends ComponenteBaseStepper {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: () => ({ id: 0, nombre: '', estado: '' }) })
  perfil!: PerfilesInterface;

  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Perfiles;
  permisosActuales: PermisoAccionVm[] = [];

  informacionGeneral: PermisoAccionVm = {
    accion: 'Crear - Información General',
    visible: true,
    step: 1,
    codigoSubAccion: 19,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  asociarModulos: PermisoAccionVm = {
    accion: 'Crear - Asociar Módulos',
    visible: true,
    step: 2,
    codigoSubAccion: 22,
    codigoAccionPadre: CodigoAccion.Crear,
    validacion: this.asociarModulosValidador,
  };

  asociarAcciones: PermisoAccionVm = {
    accion: 'Crear - Asociar Acciones',
    visible: true,
    step: 3,
    codigoSubAccion: 20,
    codigoAccionPadre: CodigoAccion.Crear,
    validacion: this.asociarModulosValidador,
  };

  permisosTotales: PermisoAccionVm[] = [
    this.informacionGeneral,
    this.asociarModulos,
    this.asociarAcciones,
  ];

  acc: any = [];
  controller: string = 'Perfil';
  controllerPostgres: string = 'Metabase/PostgenericA';
  funcionalidadAccionController: string = 'funcionalidadAccion';
  readonly controllerClienteRol: string = 'clienterol';
  readonly rolTransversalController: string = 'RolTransversal';
  readonly controllerUsuario: string = 'usuario';
  loadingService = new LoadingService();

  //Variables globales
  localeText = config.agGridTextos;
  $snotify: any;
  e1: number = 1;
  btnText: string = 'Continuar';
  search: string = '';
  btnColor: string = '#ffe800'; //'#669933'
  dialog: boolean = false;
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;
  validForm: boolean = false;
  btnBloquear: boolean = false;
  editedItem: PerfilesInterface = {};
  dictionaryFormErrors: any = {};
  handleErrors: HandleErrors = new HandleErrors();
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  axiosCliente: AxiosVue = new AxiosVue(ServicioProxy.Cliente);
  axiosPostgres: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  axiosPostgresAws: AxiosVue = new AxiosVue(ServicioProxy.MetabaseAws);
  acciones: any = [];
  seleccionoTodos: boolean = false;
  clienteId: number = config.getClienteSesion();
  funcRules: any = [];
  varAux: number = 0;
  clickMenu: boolean = false;
  textoMsjAlerta: string = '';
  tituloMsjAlerta: string = '';
  tieneAccionesCheck: boolean = false;

  gridApiFuncionalidades: GridApi;
  columnApiFuncionalidades: ColumnApi;
  columnDefsFuncionalidades: Array<ColDef> = [];

  funcionalidadAccionAsignadosModel: any = [];
  modulosAccionAsignados: any[] = [];
  modulosAccionRespaldo: any[] = [];
  accionesSeleccionadas: any[] = [];
  accionesSeleccionadasArbol: any[] = [];
  seleccionoTodosModulos: boolean = false;
  aux: boolean = false;
  usuarioId: number = store.state.userId;
  responserolesUsuario: any = {};
  accionesGuardadas: any[] = [];

  arbolNuevo: any = [];
  accionesTreeView: any = [];

  //Roles Transversales
  rolesRespaldo: RolesInterface[] = [];

  buscarModulosNuevo: string = '';
  boolModulos: boolean = false;
  showAlertaModulo: boolean = false;

  created() {
    this.chequearPermisos();
    this.registrarValidadores();
  }

  volver() {
    this.e1 -= 1;
    this.btnText = 'Continuar';
    this.btnColor = '#ffe800';
    document.getElementById('cardDivP').scrollIntoView(true);
    if (this.accionesSeleccionadasArbol.length > 0) {
      this.accionesGuardadas = this.accionesSeleccionadasArbol;
    }
  }

  mounted() {
    this.columnDefsFuncionalidades = [
      {
        headerName: '',
        field: 'checked',
        width: 70,
        minWidth: 70,
        pinned: 'left',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        suppressMenu: true,
        resizable: true,
        sortable: true,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        cellStyle: { textAlign: 'left' },
        cellRenderer: (r: any) => {
          if (r.data.checked) {
            return r.node.setSelected(r.data.checked);
          }
        },
      },
      {
        headerName: 'Código',
        field: 'id',
        hide: true,
        resizable: false,
        sortable: true,
        lockPinned: true,
        minWidth: 80,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 80,
        lockPinned: true,
        lockVisible: true,
        cellStyle: { textAlign: 'left' },
        comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
          return config.caseInsensitiveSort(
            valueA,
            valueB,
            nodeA,
            nodeB,
            isInverted
          );
        },
      },
      {
        headerName: 'Estado',
        field: 'estadoTxt',
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 80,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Creación',
        field: 'fechaCreacion',
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 80,
        lockPinned: true,
        valueFormatter: this.fechaFilter,
        cellStyle: { textAlign: 'left' },
        getQuickFilterText: () => null,
      },
      {
        headerName: 'Fecha Modificación',
        field: 'fechaModificacion',
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 80,
        lockPinned: true,
        valueFormatter: this.fechaFilter,
        cellStyle: { textAlign: 'left' },
        getQuickFilterText: () => null,
      },
      {
        field: 'fechaCreacionTxt',
        hide: true,
        filter: false,
        lockVisible: true,
        suppressToolPanel: true,
      },
      {
        field: 'fechaModificacionTxt',
        hide: true,
        filter: false,
        lockVisible: true,
        suppressToolPanel: true,
      },
    ];

    this.dictionaryFormErrors = {
      custom: {
        id: {
          required: () => config.errorMensajes.textoRequerido,
        },
        nombre: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        funcionalidad: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
      },
    };

    this.$validator.localize('es', this.dictionaryFormErrors);

    this.funcRules = [
      (v: any) => !!v || config.errorMensajes.textoRequerido,
      (v: any) =>
        this.validarAlMenosUnaFuncionalidad() ||
        '* Debe seleccionar al menos un Módulo.',
    ];

    this.obtenerRolesAsignados(this.usuarioId);
  }

  async obtenerRolesAsignados(usuarioId: number) {
    try {
      this.responserolesUsuario = await this.axios.http.get(
        `${this.controllerUsuario}/${usuarioId}/clienterol/`
      );
    } catch (error) {
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.$snotify.error(
            'Ocurrió un error al obtener los roles asignados.'
          );
        }
      } else {
        this.$snotify.error('Ocurrió un error al obtener los roles asignados.');
      }
    }
  }

  private asociarModulosValidador() {
    const loadingKey = 'asociarModulosValidador';
    this.loadingService.showLoading(undefined, loadingKey);
    const formVal: any = this.$refs;
    this.arbolNuevo = [];

    this.modulosAccionAsignados.forEach(modulo => {
      this.arbolNuevo.push({
        id: modulo.id,
        name: modulo.nombre,
        children: [],
        accionesChildren: modulo.children,
      });
    });

    this.arbolNuevo.forEach((tv: any) => {
      let childrenAcciones: any = {};
      if (tv.accionesChildren.length > 0) {
        tv.accionesChildren.forEach((accion: any) => {
          childrenAcciones = {
            id: accion.id,
            name: accion.nombre,
            children: [],
          };

          // selecciono todos los consultar
          if (
            accion.accionCodigo === CodigoAccion.Consultar ||
            accion.accionCodigo === CodigoAccion.GenerarGenerarInforme ||
            accion.accionCodigo === CodigoAccion.GenerarInformaciónGeneral ||
            accion.accionCodigo ===
              CodigoAccion.GenerarAsociarFlotasEtiquetasVehículos
          ) {
            this.accionesSeleccionadasArbol.push(accion.id);
          }

          // tiene SubAcciones
          if (accion.children !== null) {
            accion.children.forEach((subAccion: any) => {
              let childrenSubAcciones: any = {};
              childrenSubAcciones = {
                id: subAccion.id,
                name: subAccion.nombre,
                children: [],
              };

              childrenAcciones.children.push(childrenSubAcciones);
            });
          }

          tv.children.push(childrenAcciones);
        });
      }
    });

    this.accionesTreeView = this.arbolNuevo;

    setTimeout(() => {
      this.habilitaCheckConsultar(),
        this.loadingService.hideLoading(loadingKey);
    }, 2000);

    return formVal.form.validate();
  }

  private registrarValidadores() {
    const self = this;
    const clienteId = config.getClienteSesion();

    Validator.extend('PerfilNombreUnicoCrear', {
      getMessage(field: any, params: any, data: any) {
        return '* Ya existe un Perfil con este nombre.';
      },
      validate(value: any) {
        if (value !== '') {
          const body = {
            id: 0,
            clienteId,
            nombre: value,
          };

          return self.axiosPostgresAws.http
            .post(`${self.controllerPostgres}/perfil/checkNombreUnico`, {
              ...body,
            })
            .then(response => {
              const {
                MENSAJE_RESPUESTA,
                CODIGO_RESPUESTA,
                data,
              } = response.data;
              const cod: number = Number(CODIGO_RESPUESTA);
              if (cod !== 1) throw new Error(MENSAJE_RESPUESTA);

              return new Promise(resolve => {
                resolve({
                  valid: data,
                  data: data
                    ? undefined
                    : { message: '* Ya existe un Perfil con este nombre.' },
                });
              });
            })
            .catch(err => {
              if (err instanceof Error && err.message !== 'Network Error') {
                self.$snotify.error(err.message, { timeout: 3000 });
              }
              return true;
            });
        } else {
          return true;
        }
      },
    });
  }

  isExternalFilterPresentModulo(): boolean {
    return true;
  }

  doesExternalFilterPassModulo(node: RowNode): boolean {
    if (
      this.modulosAccionRespaldo.length > 0 &&
      this.buscarModulosNuevo.length > 1
    ) {
      let busqueda = this.buscarModulosNuevo.toLowerCase();
      return (
        node.data.nombre.toLowerCase().includes(busqueda) ||
        node.data.estadoTxt.toLowerCase().includes(busqueda) ||
        node.data.fechaCreacionTxt.toLowerCase().includes(busqueda) ||
        node.data.fechaModificacionTxt.includes(busqueda)
      );
    }
    return true;
  }

  validarAlMenosUnaFuncionalidad(): boolean {
    if (this.e1 === this.asociarModulos.step) {
      return this.modulosAccionAsignados.length > 0;
    }

    return true;
  }

  @Watch('show')
  async onPropertyChanged(value: boolean, oldValue: boolean) {
    this.btnBloquear = false;
    this.dialog = value;
    this.btnText = 'Continuar';
    this.modulosAccionAsignados = [];
    this.funcionalidadAccionAsignadosModel = [];
    this.modulosAccionRespaldo = [];
    this.accionesSeleccionadas = [];
    this.accionesGuardadas = [];
    this.acc = [];
    this.arbolNuevo = [];
    this.accionesTreeView = [];
    this.accionesSeleccionadasArbol = [];
    this.textoMsjAlerta = '';
    this.tituloMsjAlerta = '';
    this.$validator.reset();
    if (value) {
      try {
        this.loadingService.showLoading();
        await this.obtenerFuncionalidadAcciones();
        this.seleccionoTodos = false;
        this.seleccionoTodosModulos = false;
        this.btnText = 'Continuar';
        this.btnColor = '#ffe800';
      } finally {
        this.loadingService.hideLoading();
      }
    }
  }

  marcarTodasAcciones(value: boolean) {
    this.accionesSeleccionadasArbol = [];

    if (value) {
      this.modulosAccionRespaldo.forEach((modulo: any) => {
        modulo.children.forEach((accion: any) => {
          this.accionesSeleccionadasArbol.push(accion.id);
          accion.children.forEach((subAccion: any) => {
            this.accionesSeleccionadasArbol.push(subAccion.id);
          });
        });
        this.accionesSeleccionadasArbol.push(modulo.id);
      });
    } else {
      this.modulosAccionRespaldo.forEach((modulo: any) => {
        modulo.children.forEach((accion: any) => {
          if (
            accion.accionCodigo === CodigoAccion.Consultar ||
            accion.accionCodigo === CodigoAccion.GenerarGenerarInforme ||
            accion.accionCodigo === CodigoAccion.GenerarInformaciónGeneral ||
            accion.accionCodigo ===
              CodigoAccion.GenerarAsociarFlotasEtiquetasVehículos
          ) {
            this.accionesSeleccionadasArbol.push(accion.id);
          }
        });
      });
    }
    this.seleccionoTodos = value;
  }

  continuar() {
    this.$validator.validateAll().then(resultado => {
      if (resultado) {
        document.getElementById('cardDivP').scrollIntoView(true);
        if (this.e1 > 1 && !this.boolModulos) {
          this.showAlertaModulo = true;
          this.tituloMsjAlerta = 'Seleccionar Módulo';
          this.textoMsjAlerta = 'Debe seleccionar al menos un Módulo.';
        } else {
          if (this.e1 === this.permisosActuales.length) {
            this.validarAccionCheck();
            if (this.tieneAccionesCheck) {
              this.btnBloquear = true;
              this.dialogConfirmacion = true;
            } else {
              this.showAlertaModulo = true;
              this.tituloMsjAlerta = 'Seleccionar Acción';
              this.textoMsjAlerta =
                'Debe seleccionar al menos una acción por Módulo.';
            }
            if (this.accionesSeleccionadasArbol.length > 0) {
              this.accionesGuardadas = this.accionesSeleccionadasArbol;
            }
          } else if (this.e1 === this.permisosActuales.length - 1) {
            const permiso = this.permisosActuales[this.e1 - 1];

            if (
              permiso.validacion !== undefined &&
              permiso.validacion !== null
            ) {
              if (permiso.validacion()) {
                this.e1 += 1;
                this.btnColor = '#ff6c00';
                this.btnText = 'Guardar';
              }
            } else {
              this.e1 += 1;
              this.btnText = 'Guardar';
            }
          } else {
            const permiso = this.permisosActuales[this.e1 - 1];

            if (
              permiso.validacion !== undefined &&
              permiso.validacion !== null
            ) {
              if (permiso.validacion()) {
                this.e1 += 1;
              }
            } else {
              this.e1 += 1;
            }
          }
        }
      }
    });
  }

  validarAccionCheck() {
    //valida que cada modulo tenga al menos una accion asignada
    this.tieneAccionesCheck = true;
    this.modulosAccionAsignados.forEach((modulo: any) => {
      let tieneSeleccionado = false;
      if (modulo.children.length > 0) {
        modulo.children.forEach((accion: any) => {
          let existeAccionCheck = this.accionesSeleccionadasArbol.find(
            x => x === accion.id
          );
          if (existeAccionCheck) {
            if (!tieneSeleccionado) {
              tieneSeleccionado = true;
            }
          }
        });
      }
      if (!tieneSeleccionado) {
        this.tieneAccionesCheck = false;
      }
    });
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;

    if (val) {
      const currentUserId: string = JSON.parse(localStorage.getItem('user')).id;
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loadingService.showLoading();
          this.btnBloquear = true;

          let model: any = {
            nombre: this.editedItem.nombre,
            currentClienteId: this.clienteId,
            currentUserId,
          };

          //Graba Nuevo Perfil
          this.axiosPostgresAws.http
            .post(`${this.controllerPostgres}/perfil/postPerfil`, { ...model })
            .then(res => {
              const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, data } = res.data;
              const cod: number = Number(CODIGO_RESPUESTA);
              if (cod !== 1) throw new Error(MENSAJE_RESPUESTA);

              model.Id = data.Id;
              this.grabaAsignacionModulosAccion(data.Id);
            })
            .catch(error => {
              this.loadingService.hideLoading();
              this.btnBloquear = false;
              if (error.response !== undefined) {
                if (error.response.status !== 401) {
                  this.handleErrors.showError(error);
                }
              } else {
                this.handleErrors.showError(error);
              }
            });
        }
      });
    }
    this.btnBloquear = false;
  }

  grabaAsignacionModulosAccion(idPerfil: number) {
    //Graba Asignacion de funcionalidades acciones
    if (this.accionesSeleccionadasArbol.length > 0) {
      let model: any = [];

      //Graba Asignacion de funcionalidades acciones
      this.modulosAccionAsignados.forEach((modulo: any) => {
        //Módulos con Acciones
        if (modulo.children.length > 0) {
          modulo.children.forEach((accion: any) => {
            //Acciones sin Subacciones
            let existeAccionCheck = this.accionesSeleccionadasArbol.find(
              x => x === accion.id && accion.children.length === 0
            );
            if (existeAccionCheck !== undefined) {
              model.push(accion);
            }

            //Acciones con Subacciones
            accion.children.forEach((subAccion: any) => {
              let existeSubAccionCheck = this.accionesSeleccionadasArbol.find(
                x => x === subAccion.id
              );
              if (existeSubAccionCheck !== undefined) {
                model.push(subAccion);
              }
            });
          });
        }
        //Módulos sin Acciones
        /*else {
          let existeModuloCheck = this.accionesSeleccionadasArbol.find(
            x => x === modulo.id
          );
          if (existeModuloCheck !== undefined) {
            model.push(modulo);
          }
        }*/
      });

      this.axios.http
        .post(
          `${this.funcionalidadAccionController}/${idPerfil}/grabaFuncionalidadAccionesNuevo`,
          model
        )
        .then(res => {
          this.loadingService.hideLoading();
          this.$snotify.success(
            this.$t('mensajes.mensajesExito.crear', {
              entidad: 'Perfil',
              creadoA: 'creado',
            })
          );
          this.closeModal(false);
        })
        .catch(err => {
          this.loadingService.hideLoading();
          this.btnBloquear = false;
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              this.$snotify.error(
                this.$t('mensajes.mensajesError.crear', {
                  entidad: 'el Perfil',
                })
              );
            }
          } else {
            this.$snotify.error(
              this.$t('mensajes.mensajesError.crear', { entidad: 'el Perfil' })
            );
          }
        });
    } else {
      this.loadingService.hideLoading();
      this.$snotify.success(
        this.$t('mensajes.mensajesExito.crear', {
          entidad: 'Perfil',
          creadoA: 'creado',
        })
      );
      this.closeModal(false);
    }
  }

  onClickCell(params: CellContextMenuEvent) {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 1) {
      appBanners[0].remove();
    }
  }

  cierraMenuPerfil() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal(val: boolean) {
    document.getElementById('cardDivP').scrollIntoView(true);
    this.btnBloquear = false;
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('modalAsociacionEmit', false);
    this.$validator.reset();
    this.dialog = false;
    this.buscarModulosNuevo = '';
    this.gridApiFuncionalidades.setQuickFilter('');
    this.showAlertaModulo = false;
    this.boolModulos = false;
  }

  formatoTextoAsociacion(texto: string) {
    return config.largoTextoAsociacion(texto);
  }

  onGridReadyFuncionalidad(params: GridReadyEvent) {
    this.gridApiFuncionalidades = params.api;
    this.columnApiFuncionalidades = params.columnApi;
  }

  async obtenerFuncionalidadAcciones() {
    this.modulosAccionRespaldo = [];
    try {
      this.loadingService.showLoading(null, 'obtenerFuncionalidadAcciones');
      const response = await this.axiosPostgresAws.http.post(
        `${this.controllerPostgres}/perfil/getFuncionalidadAccionesTransversal`,
        { id: 0, clienteId: this.clienteId }
      );
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, data } = response.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) throw new Error(MENSAJE_RESPUESTA);

      this.modulosAccionRespaldo = data;

      //[COPIAR PEGAR] Track 3.0 - Grillas
      this.modulosAccionRespaldo.forEach((func: any) => {
        func.estadoTxt =
          func.estado === EstadoEntidad.Sistema
            ? EstadoEntidad[EstadoEntidad.Activo]
            : EstadoEntidad[func.estado];
        func.fechaCreacionTxt = this.$options.filters.formatDate(
          func.fechaCreacion
        );
        func.fechaModificacionTxt =
          func.fechaModificacion !== null
            ? this.$options.filters.formatDate(func.fechaModificacion)
            : '';
      });
      //---
    } catch (error) {
      this.loadingService.hideLoading();
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.$snotify.error('Ocurrió un error al obtener las acciones.');
        }
      } else {
        this.$snotify.error('Ocurrió un error al obtener las acciones.');
      }
    } finally {
      this.loadingService.hideLoading('obtenerFuncionalidadAcciones');
    }
  }

  fechaFilter(r: any) {
    return this.$options.filters.formatDate(r.value);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  //Aplica estilos para bloqueos de checkConsultar
  setCheckConsultar() {
    var claseCheck =
      'v-icon v-treeview-node__checkbox v-icon--link material-icons theme--light indigo--text';
    var labelElemento = document.getElementsByClassName(
      'v-treeview-node__label'
    ) as HTMLCollectionOf<HTMLElement>;

    if (labelElemento.length > 0) {
      for (let item of labelElemento) {
        const rootNode = item.parentElement.parentElement;

        if (
          item.innerText.toUpperCase() == 'CONSULTAR' ||
          item.innerText.toUpperCase() == 'GENERAR - INFORMACIÓN GENERAL' ||
          item.innerText.toUpperCase() ==
            'GENERAR - ASOCIAR FLOTAS ETIQUETAS O VEHÍCULOS' ||
          item.innerText.toUpperCase() == 'GENERAR - GENERAR INFORME'
        ) {
          let iconos = rootNode.getElementsByTagName('i') as HTMLCollectionOf<
            HTMLElement
          >;
          for (let icono of iconos) {
            if (icono.classList.contains('v-treeview-node__toggle')) {
              icono.addEventListener('click', this.setCheckConsultar);
              continue;
            }
            icono.className = claseCheck;
            icono.textContent = 'check_box';
            icono.style.cursor = 'default';
            icono.style.setProperty('color', '#9e9e9e', 'important');

            icono.outerHTML =
              '<div disabled="disabled">' + icono.outerHTML + '</div>';
          }
        }
      }
    }
  }

  habilitaCheckConsultar() {
    let arbolPermisos = document.getElementById('arbolPermisos');
    let aqui = this;
    // aqui.setCheckConsultar();
    for (let elemento1 of arbolPermisos.children) {
      if (elemento1.children.length > 0) {
        for (let elemento2 of elemento1.children) {
          if (elemento2.children[1]) {
            elemento2.children[1].addEventListener('click', function() {
              aqui.reestableceConsultarCheck();
              aqui.setCheckConsultar();
            });
          }

          if (elemento2.children[0]) {
            elemento2.children[0].addEventListener('click', function() {
              aqui.reestableceConsultarCheck();
              aqui.setCheckConsultar();
            });
          }
        }
      }
    }
    if (this.accionesGuardadas.length != 0) {
      this.accionesSeleccionadasArbol = this.accionesGuardadas;
    }
  }

  reestableceConsultarCheck() {
    this.modulosAccionAsignados.forEach(modulo => {
      modulo.children.forEach((accion: any) => {
        if (
          accion.accionCodigo === CodigoAccion.Consultar ||
          accion.accionCodigo === CodigoAccion.GenerarGenerarInforme ||
          accion.accionCodigo ===
            CodigoAccion.GenerarAsociarFlotasEtiquetasVehículos ||
          accion.accionCodigo === CodigoAccion.GenerarInformaciónGeneral
        ) {
          this.accionesSeleccionadasArbol.push(accion.id);
        }
      });
    });
  }

  preventEnterPerfiles(event: any) {
    if (event.key == 'Enter') {
      event.preventDefault();
    }
  }

  @Watch('accionesSeleccionadasArbol')
  async changeAcciones() {
    let accionesSeleccionadas: number[] = [];

    const accionesModulos = this.modulosAccionAsignados.flatMap(
      acciones => acciones.children
    );

    const subAccionesModulos = accionesModulos.flatMap(
      subAccion => subAccion.children
    );

    const accionesTotales: number =
      accionesModulos.length + subAccionesModulos.length;

    const filtrarAccionesTotales = accionesModulos.filter(accion => {
      let existe = this.accionesSeleccionadasArbol.find(x => x == accion.id);
      if (existe !== undefined) {
        accionesSeleccionadas.push(existe);
      }
    });

    const filtrarSubAccionesTotales = subAccionesModulos.filter(accion => {
      let existe = this.accionesSeleccionadasArbol.find(x => x == accion.id);
      if (existe !== undefined) {
        accionesSeleccionadas.push(existe);
      }
    });

    if (accionesTotales === accionesSeleccionadas.length) {
      this.seleccionoTodos = true;
    } else {
      this.seleccionoTodos = false;
    }
  }

  onFilterTextBoxChangedModulos() {
    this.gridApiFuncionalidades.onFilterChanged();
    // if (this.buscarModulosNuevo.length > 1) {
    //   this.gridApiFuncionalidades.setQuickFilter(this.buscarModulosNuevo);
    // } else {
    //   this.gridApiFuncionalidades.setQuickFilter('');
    // }
  }

  onSelectedChangeModulos() {
    this.acc = [];
    this.modulosAccionAsignados = this.gridApiFuncionalidades.getSelectedRows();

    if (this.modulosAccionAsignados.length) this.boolModulos = true;
    else this.boolModulos = false;

    const modulosSeleccionados = this.gridApiFuncionalidades
      .getSelectedNodes()
      .map(node => ({ ...node.data, checked: true }));

    const modulosNoSeleccionados = differenceBy(
      this.modulosAccionRespaldo,
      modulosSeleccionados,
      func => func.id
    ).map(func => ({
      ...func,
      checked: false,
    }));

    this.gridApiFuncionalidades.updateRowData({
      update: [...modulosNoSeleccionados, ...modulosSeleccionados],
    });
  }
  getRowNodeId(func: IFuncionalidad) {
    if (!func) {
      return;
    }
    return func.id;
  }

  procesarFecha(params: any) {
    if (
      params.column.getColDef().field === 'fechaCreacion' ||
      params.column.getColDef().field === 'fechaModificacion'
    ) {
      return this.$options.filters.formatDate(params.value);
    } else {
      return params.value;
    }
  }

  confirmCallbackModulo() {
    this.showAlertaModulo = false;
  }
}
